import _omitBy from "lodash/omitBy";
import _isNil from "lodash/isNil";
const filterShallowUndefinedObjectEntries = (obj) => {
  return _omitBy(obj, _isNil);
};
export {
  filterShallowUndefinedObjectEntries
};
//# sourceMappingURL=objectUtils.js.map
